module.exports = __webpack_public_path__ + "img/reclame-aqui-logo.fff7341f.png";